function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToctopusLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338,
    height: 325,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#010302",
    d: "M166.5.5c29.418.446 51.584 13.113 66.5 38 7.709 20.128 5.042 38.795-8 56L210.5 109l67 1c3.833.5 6 2.667 6.5 6.5 1.011 4.281.177 8.114-2.5 11.5-26.989 2.915-53.989 2.582-81-1-9.982-2.593-13.149-8.76-9.5-18.5a276.297 276.297 0 0 1 18-26c12.063-20.897 8.897-39.063-9.5-54.5-16.521-9.504-33.854-11.504-52-6-13.471 6.8-22.638 17.3-27.5 31.5-.82 7.551.847 14.552 5 21a114.406 114.406 0 0 0 17 19c8.842 8.871 9.675 18.371 2.5 28.5-7.592 4.768-15.926 6.768-25 6-21.667.667-43.333.667-65 0a9.457 9.457 0 0 1-2.5-1.5c-1.71-3.711-1.71-7.378 0-11a6.977 6.977 0 0 1 3.5-2.5 245.579 245.579 0 0 1 17-2l56-1c-10.497-9.833-18.664-21.333-24.5-34.5-6.48-17.258-3.814-32.925 8-47 14.771-16.135 32.938-25.468 54.5-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#030404",
    d: "M193.5 135.5c3.149-.289 6.149.211 9 1.5a991.25 991.25 0 0 1 58 48c7.509 5.687 7.842 11.687 1 18-4.487 2.039-8.82 1.706-13-1a2452.851 2452.851 0 0 1-61.5-53.5c-2.122-6.4.045-10.733 6.5-13ZM135.5 138.5c8.171-2.086 13.504.748 16 8.5a16.2 16.2 0 0 1-1.5 3.5L92.5 200c-8.48 6.781-15.647 5.614-21.5-3.5-.635-2.135-.301-4.135 1-6a668.258 668.258 0 0 1 63.5-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#020304",
    d: "M162.5 145.5a84.902 84.902 0 0 1 13 .5c2.602.935 4.102 2.768 4.5 5.5a2160.85 2160.85 0 0 1-1 72c-.652 2.223-2.152 3.39-4.5 3.5a42.479 42.479 0 0 1-13 0c-1.987-1.319-3.154-3.152-3.5-5.5-.317-23.619.016-47.286 1-71 .697-2.084 1.864-3.751 3.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#1a1818",
    d: "M27.5 253.5c18.334.168 28.667 9.334 31 27.5-1.185 17.185-10.351 26.351-27.5 27.5-16.431-1.597-25.264-10.597-26.5-27 .61-15.256 8.276-24.59 23-28Zm-2 11c17.603-.56 24.436 7.773 20.5 25-4.848 7.556-11.682 10.056-20.5 7.5-11.4-6.207-13.9-15.04-7.5-26.5 2.114-2.621 4.614-4.621 7.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.907
    },
    fill: "#1a1918",
    d: "M86.5 253.5c11.131-1.187 20.131 2.479 27 11-1.171 3.672-3.671 5.672-7.5 6a52.657 52.657 0 0 1-10.5-5.5c-14.334-1.266-21.167 5.234-20.5 19.5 1.968 8.134 7.135 12.468 15.5 13a77.998 77.998 0 0 0 16-5c4.543.741 6.376 3.408 5.5 8-11.663 9.273-24.163 10.439-37.5 3.5-11.68-10.58-14.18-23.08-7.5-37.5 4.799-6.976 11.299-11.31 19.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#191818",
    d: "M170.5 253.5c22.789.624 32.955 12.291 30.5 35-4.856 14.684-15.023 21.184-30.5 19.5-17.091-4.664-24.258-15.83-21.5-33.5 3.115-11.283 10.282-18.283 21.5-21Zm-1 11c17.071-.762 23.904 7.238 20.5 24-1.5 4.167-4.333 7-8.5 8.5-13.694 2.798-21.36-2.702-23-16.5.594-7.572 4.261-12.905 11-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.904
    },
    fill: "#1b1a19",
    d: "M304.5 253.5c7.072-.38 12.572 2.287 16.5 8-.46 5.116-3.294 7.283-8.5 6.5-3.318-4.382-6.318-4.382-9 0a182.911 182.911 0 0 0 16.5 15.5c6.544 14.244 2.044 22.577-13.5 25-7.55-.266-12.883-3.766-16-10.5 1.427-3.063 3.761-5.229 7-6.5 3.024 2.035 6.024 4.035 9 6 2.932-.295 4.932-1.795 6-4.5L295 275.5c-5.237-11.179-2.07-18.513 9.5-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.904
    },
    fill: "#201f1e",
    d: "M116.5 255.5c9.763-.624 19.263.043 28.5 2a12.494 12.494 0 0 1 0 7 30.935 30.935 0 0 1-8 3l-1 37c-3.667 2.667-7.333 2.667-11 0l-1-37a127.9 127.9 0 0 0-7.5-3c-1.325-3.031-1.325-6.031 0-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#221f20",
    d: "M211.5 255.5c6.342-.166 12.675 0 19 .5 4.343 1.01 7.51 3.51 9.5 7.5.839 5.421.506 10.754-1 16a17.842 17.842 0 0 1-5.5 4.5c-4.101.589-7.934 1.755-11.5 3.5-1.458 2.862-1.625 5.862-.5 9a34.446 34.446 0 0 1-2 9.5c-3.26.784-6.427.617-9.5-.5a552.224 552.224 0 0 1 0-47l1.5-3Zm10 10c6.097-1.237 8.93 1.097 8.5 7-8.36 4.355-11.194 2.022-8.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.926
    },
    fill: "#1c1b1a",
    d: "M250.5 255.5c2.948-.277 5.781.056 8.5 1l1 34c2 7.333 6 8.667 12 4l1-4a581.022 581.022 0 0 1 1.5-34c2.994-1.248 5.994-1.248 9 0a220.92 220.92 0 0 1 .5 36c-1.824 12.345-8.99 17.512-21.5 15.5-9.776-2.687-14.276-9.187-13.5-19.5a240.38 240.38 0 0 1 0-31c.717-.544 1.217-1.211 1.5-2Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToctopusLogo1);
export default __webpack_public_path__ + "static/media/toctopus-logo (1).3a696547abbc95389aefd2665bb7d5f2.svg";
export { ForwardRef as ReactComponent };